var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { Typography, Popover, Box } from '@mui/material';
import { BackrsIcon } from './BackrsIcon';
import { appBorders } from '../assets/appBorders';
import { appColors } from '../assets/appColors';
import { DATA_DICTIONARY, } from '../assets/dataDictionary';
import { PanelNugget } from '../molecules/Nugget/PanelNugget';
export function HighlightableText(_a) {
    var text = _a.text, style = _a.style, textVariant = _a.textVariant, additionalDictionary = _a.additionalDictionary;
    var combinedDictionary = __assign(__assign({}, DATA_DICTIONARY), additionalDictionary);
    var escapedKeys = Object.keys(combinedDictionary).map(function (key) {
        return key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    var regex = new RegExp("(".concat(escapedKeys.join('|'), ")"), 'gi');
    var parts = text.split(regex);
    return (_jsx(Typography, { component: "span", sx: style, variant: textVariant, children: parts.map(function (part, index) {
            var _a;
            var partKey = part;
            if (partKey in combinedDictionary) {
                return (_jsx(HighlightedWordWithPopover, { word: part.replace(/{{|}}/g, ''), blurb: combinedDictionary[partKey].values, title: (_a = combinedDictionary[partKey].title) === null || _a === void 0 ? void 0 : _a.replace(/{{|}}/g, ''), displayListType: combinedDictionary[partKey].displayType }, index));
            }
            return (_jsx(Typography, { component: "span", children: part.replace(/{{|}}/g, '') }, index));
        }) }));
}
var HighlightedWordWithPopover = function (_a) {
    var word = _a.word, blurb = _a.blurb, title = _a.title, displayListType = _a.displayListType;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'word-popover' : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", sx: keywordSx, onClick: handleClick, id: id, children: word }), _jsx(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'center',
                    horizontal: 'left',
                }, PaperProps: {
                    sx: __assign(__assign({}, paperSx), (displayListType.type === 'nugget' ? nuggetSx : {})),
                }, children: _jsx(PopoverContent, { displayListType: displayListType, word: word, blurb: blurb, title: title }) })] }));
};
var PopoverContent = function (_a) {
    var _b, _c;
    var displayListType = _a.displayListType, word = _a.word, blurb = _a.blurb, title = _a.title;
    if (displayListType.type === 'nugget') {
        return (_jsxs(Box, { children: [_jsx(Box, { onClick: function () { return window.open(displayListType.onClickUrl, '_blank'); }, sx: nuggetArrowIconSx, children: _jsx(BackrsIcon, { name: "IconArrowOut", alt: "icon" }) }), _jsx(PanelNugget, { variant: displayListType.panelNuggetVariant, title: (((_b = blurb[0]) === null || _b === void 0 ? void 0 : _b.title) || '')
                        .split(' ')
                        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                        .join(' '), body: (_c = blurb[0]) === null || _c === void 0 ? void 0 : _c.description })] }));
    }
    var Content = function () {
        switch (displayListType.type) {
            case 'bullet':
                return (_jsx("ul", { style: listStyle, children: blurb.map(function (item, index) { return (_jsxs("li", { style: listItemStyle, children: [item.title ? _jsx("span", { style: listItemTitleStyle, children: item.title }) : '', item.description] }, index)); }) }));
            case 'number':
                return (_jsx("ol", { style: listStyle, children: blurb.map(function (item, index) { return (_jsxs("li", { style: listItemStyle, children: [item.title ? _jsxs("span", { style: listItemTitleStyle, children: [item.title, " "] }) : '', item.description] }, index)); }) }));
            case 'block':
                return (_jsx(Box, { children: blurb.map(function (item) {
                        return (_jsxs(Fragment, { children: [item.title ? (_jsx(Typography, { variant: "h6", mb: 2, children: item.title })) : (''), _jsx(Typography, { children: item.description })] }, item.description));
                    }) }));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: __assign(__assign({}, titleSx), { fontSize: 17 }), children: word
                    .split(' ')
                    .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                    .join(' ') }), title && _jsx(Typography, { sx: titleSx, children: title }), _jsx(Content, {})] }));
};
var paperSx = {
    fontSize: '14px',
    padding: 2,
    backgroundColor: appColors.neutral.black,
    color: appColors.neutral.white,
    borderRadius: 4,
    whiteSpace: 'pre-line',
    boxSizing: 'border-box',
    minWidth: '450px',
    maxWidth: '450px',
};
var listStyle = {
    margin: 0,
    paddingLeft: '16px',
};
var listItemStyle = {
    marginBottom: '8px',
};
var listItemTitleStyle = {
    fontWeight: 600,
};
var titleSx = {
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: '12pt',
    mb: 2,
};
var keywordSx = {
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.5,
    },
};
var nuggetSx = {
    maxWidth: '400px',
    backgroundColor: 'white',
    color: 'black',
    padding: 0,
    boxShadow: appBorders.backrsDropShadowBorders.black,
};
var nuggetArrowIconSx = {
    position: 'absolute',
    top: 20,
    right: 20,
    cursor: 'pointer',
};
